module.exports = __webpack_public_path__ + "img/collaborate_3.0a078b25.jpg";